"use client";
import Image from "@/components/Image";

const About = () => {
  return (
    <section className="w-full bg-white">
      {/*关于我们*/}
      <div className="w-full px-[80px] [@media(min-width:769px)_and_(max-width:1080px)]:px-[40px] [@media(max-width:768px)]:px-[20px] gap-[10px]">
        <div className="w-full max-w-[1360px] pt-[90px] pb-[50px] mx-auto flex flex-col gap-[40px]">
          <div className="font-[PingFang-SC] font-semibold text-[46px] [@media(max-width:414px)]:text-[40px] leading-[52px] tracking-[0px] text-center text-[#333333]">
            关于我们
          </div>
          <div className="w-full rounded-[20px] px-[40px] [@media(max-width:660px)]:px-[20px] py-[44px] bg-[#F8FAFD] font-[PingFang-SC] font-normal text-[18px] leading-[34px] tracking-[0px] text-[#666666]">
            上海临冠数据科技有限公司，是一家人工智能科技企业，基于自主研发的领先的智能文字识别核心技术，为全球C端用户和多元行业B端客户提供数字化、智能化的产品及服务。
            <br />
            蜜蜂家校的AI算法能力始终专注坚持原卷手写作答批改，努力攻克字迹潦草、题型密集等问题，拓展产品适用面且做到使用门槛低：日常练习册、作业单、小测验、单元练习等都能处理。旨在让蜜蜂家校这个产品真正做到“真有用，真好用”。
            <br />
            BG业务更是聚焦作业场景，从采集到批改留痕再到学情分析做到精准闭环，让精准教学获得AI助力，教育局、学校、老师有的放矢，家长了解学习情况，不搞“题海战术”，学生学科核心素养提升看得见。
            <br />
          </div>
        </div>
      </div>
      {/*蜜蜂教育*/}
      <div className="w-full px-[80px] [@media(min-width:769px)_and_(max-width:1080px)]:px-[40px] [@media(max-width:768px)]:px-[20px] gap-[10px]">
        <div className="w-full max-w-[1360px] pt-[90px] pb-[140px] mx-auto flex flex-col gap-[80px]">
          <div className="font-[PingFang-SC] font-semibold text-[46px] [@media(max-width:414px)]:text-[40px] leading-[52px] tracking-[0px] text-center text-[#333333]">
            蜜蜂教育
          </div>
          <div className="w-full flex [@media(max-width:768px)]:flex-col flex-row gap-[50px]">
            {/*蜜蜂AI*/}
            <div className="w-full rounded-[20px] px-[40px] [@media(max-width:660px)]:px-[20px] py-[44px] flex flex-col gap-[34px] hover:bg-[#F6F8FB] [@media(max-width:768px)]:bg-[#F6F8FB]">
              <div className="w-full">
                <Image
                  src="/bee_ai_11.png"
                  alt="蜜蜂AI"
                  width={120}
                  height={120}
                  className="mx-auto"
                />
              </div>
              <div className="w-full flex flex-col gap-[20px]">
                <div className="font-[PingFang-SC] font-semibold text-[24px] leading-[24px] tracking-[0px] text-center text-[#333333]">
                  蜜蜂AI
                </div>
                <div className="font-[PingFang-SC] font-normal text-[18px] leading-[34px] tracking-[0px] text-[#666666]">
                  专注“教+学”领域，充分发挥扫描全能王在文字识别上多年积累的技术和经验，从教学实践的优化到文化传承的推动，从思维能力的塑造到教学管理的革新，全方位发挥着重要作用，为教与学的发展与提升注入强大动力，促进教学向更高效、更丰富、更个性化的方向迈进。
                </div>
              </div>
            </div>
            {/*蜜蜂家校*/}
            <div className="w-full rounded-[20px] px-[40px] py-[44px] flex flex-col gap-[34px] hover:bg-[#F6F8FB] [@media(max-width:768px)]:bg-[#F6F8FB]">
              <div className="w-full">
                <Image
                  src="/bee_school_11.png"
                  alt="蜜蜂家校"
                  width={120}
                  height={120}
                  className="mx-auto"
                />
              </div>
              <div className="w-full flex flex-col gap-[20px]">
                <div className="font-[PingFang-SC] font-semibold text-[24px] leading-[24px] tracking-[0px] text-center text-[#333333]">
                  蜜蜂家校
                </div>
                <div className="font-[PingFang-SC] font-normal text-[18px] leading-[34px] tracking-[0px] text-[#666666]">
                  面向老师和家长：家校共育效率微信小程序，提供多样化作业管理、AI精准学情分析、全场景家校沟通等服务。
                </div>
              </div>
            </div>
            {/*蜜蜂试卷*/}
            <div className="w-full rounded-[20px] px-[40px] py-[44px] flex flex-col gap-[34px] hover:bg-[#F6F8FB] [@media(max-width:768px)]:bg-[#F6F8FB]">
              <div
                className="w-full cursor-pointer"
                onClick={() => {
                  window.open(
                    "https://www.mifeng.plus/",
                    "_blank",
                    "noopener,noreferrer",
                  ); // 外部链接需处理为新标签页
                }}
              >
                <Image
                  src="/bee_paper_11.png"
                  alt="蜜蜂试卷"
                  width={120}
                  height={120}
                  className="mx-auto"
                />
              </div>
              <div className="w-full flex flex-col gap-[20px]">
                <div className="font-[PingFang-SC] font-semibold text-[24px] leading-[24px] tracking-[0px] text-center text-[#333333]">
                  蜜蜂试卷
                </div>
                <div className="font-[PingFang-SC] font-normal text-[18px] leading-[34px] tracking-[0px] text-[#666666]">
                  面向家长：学习辅助的手机APP应用软件，提供整理错题本、检查作业、清除试卷笔迹、拍题等服务。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
